import { useState } from "react";
import "./Signin.css";
import { FaUserTie, FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Signup() {
  const [signup, setsignup] = useState(true);
  const [vendorsignup, setvendorsignup] = useState(false);
  const [clientsignup, setclientsignup] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const navigate = useNavigate();

  const handlesignup = (type) => {
    if (type === "vendor") {
      setsignup(false);
      setvendorsignup(true);
    } else {
      setsignup(false);
      setclientsignup(true);
    }
  };

  const [Demo, setDemo] = useState({
    username: "",
    password: "",
    cpassword: "",
    email: "",
    companyname: "",
    companyurl: "",
    companysize: "",
    phno: "",
    agree: false,
  });

  const validatesignup = async (admin, event) => {
    event.preventDefault();
    if (!Demo.agree) {
      alert("You must agree to the terms and conditions to sign up.");
      return;
    }
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/signup.php`;
    const formData = new FormData();
    try {
      if (Demo.password === Demo.cpassword) {
        const formData = new FormData();
        formData.append("type", "demo");
        formData.append("username", Demo?.username);
        formData.append("password", Demo?.password);
        formData.append("email", Demo?.email);
        formData.append("phone_no", Demo?.phno);
        formData.append("role", admin);
        formData.append("company_name", Demo?.companyname);
        formData.append("company_url", Demo?.companyurl);
        formData.append("company_size", Demo?.companysize);

        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (
          data.message ===
          "User created successfully. User ID and password have been sent to the registered email address"
        ) {
          setDemo({
            username: "",
            password: "",
            cpassword: "",
            email: "",
            companyname: "",
            companyurl: "",
            companysize: "",
            phno: "",
            agree: false,
          });
          navigate("/");
          alert(data.message);
        } else {
          alert(data.error);
        }
      } else {
        alert("Password and Confirm Password should be same");
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  return (
    <div className="wrapper">
    <div className="signin-wrapper">
      {signup && (
        <div className="signin-container">
          <div className="merchant-card" onClick={() => handlesignup("vendor")}>
            <FaUserCircle
              size={108}
              style={{
                color: "rgb(243, 57, 24)",
              }}
            />
            <p>Firm Provider</p>
          </div>
          <div className="merchant-card" onClick={() => handlesignup("client")}>
            <FaUserTie
              size={108}
              style={{
                color: "rgb(243, 148, 24)",
              }}
            />
            <p>Services Provider</p>
          </div>
        </div>
      )}

      {vendorsignup && (
        <div>
          <form onSubmit={(e) => validatesignup("cadmin", e)} className="form">
            <p className="title">Register as a Company </p>
            <p className="message">
              Signup now the demo version and get full access to our app.{" "}
            </p>
            <div className="flex">
              <div>
                <label>
                  <span>Username</span>
                  <input
                    className="input"
                    type="text"
                    required
                    value={Demo?.username}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, username: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Phone Number</span>
                  <input
                    className="input"
                    type="tel"
                    pattern="[0-9]{10}"
                    title="Enter the validate Phone Number"
                    required
                    value={Demo?.phno}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, phno: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Password</span>
                  <input
                    className="input"
                    type="password"
                    required
                    value={Demo?.password}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, password: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Confirm password</span>
                  <input
                    className="input"
                    type="password"
                    required
                    value={Demo?.cpassword}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, cpassword: e.target.value }))
                    }
                  />
                </label>
              </div>
              <div>
                <label>
                  <span>Company Name</span>
                  <input
                    className="input"
                    type="text"
                    required
                    value={Demo?.companyname}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, companyname: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Company Email</span>
                  <input
                    className="input"
                    type="email"
                    required
                    value={Demo?.email}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, email: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Company URL</span>
                  <input
                    className="input"
                    type="url"
                    value={Demo?.companyurl}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, companyurl: e.target.value }))
                    }
                    required
                  />
                </label>
                <label>
                  <span>Company Size</span>
                  <select
                    className="input"
                    type="password"
                    value={Demo?.companysize}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, companysize: e.target.value }))
                    }
                    required
                  >
                    <option value="" disabled selected>
                      Select the Company Size
                    </option>
                    <option value="1-10">1-10</option>
                    <option value="1-50">1-50</option>
                    <option value="1-100">1-100</option>
                    <option value="200+">200+</option>
                  </select>
                </label>
              </div>
            </div>

            <label className="terms-label">
              <input
                type="checkbox"
                checked={Demo.agree}
                onChange={(e) =>
                  setDemo((prev) => ({
                    ...prev,
                    agree: e.target.checked,
                  }))
                }
              />
              I agree to the{" "}
              <span className="terms-link" onClick={() => setShowTerms(true)}>
                Terms of Demo Usage
              </span>
            </label>
            <button className="submit">Submit</button>
            <p className="signin">
              Already have an acount ?{" "}
              <a onClick={() => navigate("/")}>Signin</a>{" "}
            </p>
          </form>
        </div>
      )}

      {clientsignup && (
        <div>
          <form onSubmit={(e) => validatesignup("sadmin", e)} className="form">
            <p className="title">Register as a Services Provider </p>
            <p className="message">
              Signup now the demo version and get full access to our app.{" "}
            </p>
            <div className="flex">
              <div>
                <label>
                  <span>Username</span>
                  <input
                    className="input"
                    type="text"
                    required
                    value={Demo?.username}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, username: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Phone Number</span>
                  <input
                    className="input"
                    type="tel"
                    pattern="[0-9]{10}"
                    title="Enter the validate Phone Number"
                    required
                    value={Demo?.phno}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, phno: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Password</span>
                  <input
                    className="input"
                    type="password"
                    required
                    value={Demo?.password}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, password: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Confirm password</span>
                  <input
                    className="input"
                    type="password"
                    required
                    value={Demo?.cpassword}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, cpassword: e.target.value }))
                    }
                  />
                </label>
              </div>
              <div>
                <label>
                  <span>Company Name</span>
                  <input
                    className="input"
                    type="text"
                    required
                    value={Demo?.companyname}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, companyname: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Company Email</span>
                  <input
                    className="input"
                    type="email"
                    required
                    value={Demo?.email}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, email: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Company URL</span>
                  <input
                    className="input"
                    type="url"
                    value={Demo?.companyurl}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, companyurl: e.target.value }))
                    }
                    required
                  />
                </label>
                <label>
                  <span>Company Size</span>
                  <select
                    className="input"
                    type="password"
                    value={Demo?.companysize}
                    onChange={(e) =>
                      setDemo((pv) => ({ ...pv, companysize: e.target.value }))
                    }
                    required
                  >
                    <option value="" disabled selected>
                      Select the Company Size
                    </option>
                    <option value="1-10">1-10</option>
                    <option value="1-50">1-50</option>
                    <option value="1-100">1-100</option>
                    <option value="200+">200+</option>
                  </select>
                </label>
              </div>
            </div>

            <label className="terms-label">
              <input
                type="checkbox"
                checked={Demo.agree}
                onChange={(e) =>
                  setDemo((prev) => ({
                    ...prev,
                    agree: e.target.checked,
                  }))
                }
              />
              I agree to the{" "}
              <span className="terms-link" onClick={() => setShowTerms(true)}>
                Terms of Demo Usage
              </span>
            </label>
            <button className="submit">Submit</button>
            <p className="signin">
              Already have an acount ?{" "}
              <a onClick={() => navigate("/")}>Signin</a>{" "}
            </p>
          </form>
        </div>
      )}

      {showTerms && (
        <div className="terms-modal">
          <div className="terms-content">
            <h2>Terms of Demo Account Usage</h2>
            <p>
              This demo account is valid for <strong>15 days</strong> only from
              the date of registration. It is strictly intended for{" "}
              <strong>official and evaluation purposes</strong> to help users
              explore the features of our system.
            </p>
            <ul>
              <li>
                Data provided must be accurate and belong to you or your
                organization.
              </li>
              <li>
                Demo accounts are monitored and may be contacted for feedback or
                validation.
              </li>
              <li>
                <strong>
                  Illegal, abusive, or harmful activity is strictly prohibited
                </strong>
                .
              </li>
              <li>
                All demo data may be deleted after the demo period without
                further notice.
              </li>
              <li>
                By signing up, you agree that we may contact you regarding your
                demo experience.
              </li>
            </ul>
            <p>
              We are committed to data safety and compliance. If you have
              concerns, please contact our support team.
            </p>
            <button className="close-btn" onClick={() => setShowTerms(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
    </div>
  );
}
export default Signup;
